import { CircleCheck } from "lucide-react";
const benefits = ["0% COMMISSIONS", "DIRECT CASH OFFERS"];
export default function TheMortgagenieReassurance() {
  return <section data-section-id="153574" id="why-sellers-choose-brentwood" className="dark bg-background py-8 md:py-10 border-t border-border/10">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row flex-wrap justify-center items-center gap-6 sm:gap-12 lg:gap-24">
          {benefits.map((benefit, i) => <div key={i} data-index={i} className="flex items-center gap-3 group bg-card/40 backdrop-blur-md border-l-2 border-primary hover:-translate-y-2 hover:bg-card/60 transition-all duration-300 rounded-md shadow-lg">
              <div className="bg-primary/5 rounded-md p-1 transition-colors group-hover:bg-primary/10">
                <CircleCheck className="size-6 text-primary" strokeWidth={2.5} />
              </div>
              <span className="text-base md:text-lg font-mono font-bold text-foreground tracking-tighter uppercase">
                {benefit}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}